/**
 * URL文字列に新しいクエリパラメータを追加する
 * @param url - 元のURL文字列
 * @param key - 追加するパラメータのキー
 * @param value - 追加するパラメータの値
 * @returns クエリパラメータが追加されたURL文字列
 */
export const appendQueryParam = (
  url: string,
  key: string,
  value: string | number | boolean,
): string => {
  const encodedKey = encodeURIComponent(key);
  const encodedValue = encodeURIComponent(String(value));

  // ハッシュを分離
  const [urlWithoutHash, hash] = url.split('#');
  const hashPart = hash ? `#${hash}` : '';

  // クエリ文字列を分離
  const questionMarkIndex = (urlWithoutHash ?? '').indexOf('?');

  if (questionMarkIndex === -1) {
    // クエリパラメータがない場合
    return `${urlWithoutHash ?? ''}?${encodedKey}=${encodedValue}${hashPart}`;
  }

  const baseUrl = (urlWithoutHash ?? '').substring(0, questionMarkIndex);
  const queryString = (urlWithoutHash ?? '').substring(questionMarkIndex + 1);

  // 既存のクエリパラメータをパース
  const params = new URLSearchParams(queryString);
  params.set(encodedKey, encodedValue);

  // 末尾に?だけがある場合の対応
  if (queryString === '') {
    return `${baseUrl}?${encodedKey}=${encodedValue}${hashPart}`;
  }

  return `${baseUrl}?${params.toString()}${hashPart}`;
};

/**
 * 複数のクエリパラメータを一度に追加する
 * @param url - 元のURL文字列
 * @param params - 追加するパラメータのオブジェクト
 * @returns クエリパラメータが追加されたURL文字列
 */
export const appendQueryParams = (
  url: string,
  params: Record<string, string | number | boolean>,
): string => {
  let result = url;
  for (const [key, value] of Object.entries(params)) {
    result = appendQueryParam(result, key, value);
  }
  return result;
};
